<style>
  section {
    padding: 8rem 1.5rem;
    border-top: 1px solid var(--separator);
  }

  .container {
    max-width: 1280px;
    margin: 0 auto;
  }

  h2 {
    font-family: "Bodoni Moda", serif;
    font-size: 2.25rem;
    font-style: italic;
    margin-bottom: 6rem;
    text-align: center;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8rem 2rem;
  }

  .grid-item {
    width: 100%;
  }

  .grid-item figure {
    width: 100%;
  }

  .grid-item figure > div {
    overflow: hidden;
    background: #1a1a1a;
  }

  .grid-item.portrait figure > div {
    aspect-ratio: 4/5;
  }

  .grid-item.landscape figure > div {
    aspect-ratio: 3/2;
  }

  figcaption {
    display: flex;
    justify-content: space-between;
    margin-top: 0.75rem;
    border-top: 1px solid var(--separator);
    padding-top: 0.5rem;
  }

  figcaption span {
    font-family: "Inter", sans-serif;
    color: var(--muted);
    font-size: 0.625rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  @media (min-width: 768px) {
    section {
      padding: 8rem 3rem;
    }

    .grid {
      grid-template-columns: repeat(12, 1fr);
    }

    .grid-item:nth-child(1) {
      grid-column: 2 / span 5;
    }

    .grid-item:nth-child(2) {
      grid-column: 8 / span 5;
      margin-top: 6rem;
    }

    .grid-item:nth-child(3) {
      grid-column: 4 / span 6;
    }
  }

  @media (min-width: 1024px) {
    section {
      padding: 8rem 6rem;
    }
  }
</style>

<script>
  import EditorialImage from "./components/EditorialImage.svelte";

  let { lightboxItems = $bindable([]), openLightbox = $bindable(() => {}) } =
    $props();

  const images = [
    {
      filename: "image1.jpg",
      aspectRatio: "4/5",
    },
    {
      filename: "image17.jpg",
      aspectRatio: "3/2",
    },
    {
      filename: "image18.jpg",
      aspectRatio: "4/5",
    },
  ];

  const startIndex = lightboxItems.length;
  const imageIndices = images.map((img, i) => startIndex + i);
  lightboxItems = [
    ...lightboxItems,
    ...images.map((img) => ({
      type: "image",
      filename: img.filename,
      alt: img.alt,
    })),
  ];
</script>

<section>
  <div class="container">
    <div class="grid">
      <div class="grid-item portrait">
        <figure>
          <div>
            <EditorialImage
              filename={images[0].filename}
              alt={images[0].alt}
              aspectRatio={images[0].aspectRatio}
              onclick={() => openLightbox(imageIndices[0])}
            />
          </div>
          <figcaption>
            <span>04:05 PM</span>
            <span>Moments later</span>
          </figcaption>
        </figure>
      </div>
      <div class="grid-item landscape">
        <figure>
          <div>
            <EditorialImage
              filename={images[1].filename}
              alt={images[1].alt}
              aspectRatio={images[1].aspectRatio}
              onclick={() => openLightbox(imageIndices[1])}
            />
          </div>
          <figcaption>
            <span>04:15 PM</span>
            <span>Celebratory Champagne</span>
          </figcaption>
        </figure>
      </div>
      <div class="grid-item portrait">
        <figure>
          <div>
            <EditorialImage
              filename={images[2].filename}
              alt={images[2].alt}
              aspectRatio={images[2].aspectRatio}
              onclick={() => openLightbox(imageIndices[2])}
            />
          </div>
          <figcaption>
            <span>03:55 PM</span>
            <span>Golden hour</span>
          </figcaption>
        </figure>
      </div>
    </div>
  </div>
</section>
